var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[
    'block-wrapper', 
    _vm.componentClass, 
    _vm.colorMode, 
    {
        visible: _vm.visible, 
        ready: _vm.ready
    }
]},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12 medium-10 medium-offset-1 large-7 large-offset-2 xxlarge-5 xxlarge-offset-3 text-column"},[_c('div',{staticClass:"wysiwyg-wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12 medium-8 medium-offset-2"},[(_vm.data.title)?_c('h2',[_vm._v(_vm._s(_vm.data.title))]):_vm._e(),(_vm.data.files)?_c('ul',_vm._l((_vm.data.files),function(file,fileindex){return _c('li',{key:_vm.data.component_id + '-dl-' + fileindex},[_c('a',{staticClass:"has-icon icon-right download",attrs:{"href":file.url}},[_vm._v(_vm._s(file.title)+" "),_c('span',{staticClass:"file-size"},[_vm._v(_vm._s(file.size))])])])}),0):_vm._e()])])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }